export default "__VITE_ASSET__DZuMVohY__"